/**
 * This page's chart-lock session. Page-scoped rather than per mount: an editor
 * that remounts (a list re-render, a route boundary) must recognise the lock it
 * already holds, or it reads its own lock as "another tab" and goes read-only.
 * A reload or another tab is a new page, so those still coordinate.
 */
export const chartLockSessionId: string = crypto.randomUUID();
